import { BASE_URL } from "../static/constants";

const customFetch = async (url, options) => {
  let response,
    json,
    exception = null;
  try {
    response = await fetch(url, options);
    const data = await response.json();
    if (!response.ok) {
      throw data.message;
    }
    json = data;
  } catch (error) {
    exception = error;
  }
  return [json, exception];
};

const getToken = () => {
  return localStorage.getItem("authToken");
};

const setPhysicians = (physicians) => {
  return {
    type: "SET_PHYSICIANS",
    payload: physicians,
  };
};

const setIntervals = (intervals) => {
  return {
    type: "SET_INTERVALS",
    payload: intervals,
  };
};

const deleteInterval = (id) => {
  return {
    type: "REMOVE_INTERVAL",
    payload: id,
  };
};

export const setError = (message) => {
  return {
    type: "SET_ERROR",
    payload: message,
  };
};

export const setOk = (message) => {
  return {
    type: "SET_OK",
    payload: message,
  };
};

export const setLoading = (state) => {
  return {
    type: "SET_LOADING",
    payload: state,
  };
};

export const getPhysicians = (token) => {
  return async (dispatch, getSate) => {
    const [json, error] = await customFetch(
      `${BASE_URL}/v2/transmissions/physicians`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    if (json) {
      dispatch(setPhysicians(json));
      dispatch(setError(""));
      return;
    }
    dispatch(setOk(""));
    dispatch(setError(error));
  };
};

export const getItervals = (token) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    const [json, error] = await customFetch(`${BASE_URL}/scheduling/all`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (json) {
      dispatch(setIntervals(json));
      dispatch(setError(""));
      dispatch(setLoading(false));
      return;
    }
    dispatch(setOk(""));
    dispatch(setError(error));
    dispatch(setLoading(false));
  };
};

export function removeInterval(id) {
  return async function (dispatch, getState) {
    dispatch(setLoading(true));
    const [json, error] = await customFetch(`${BASE_URL}/scheduling`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (json) {
      dispatch(deleteInterval(id));
      dispatch(setError(""));
      dispatch(setLoading(false));
      return;
    }
    dispatch(setOk(""));
    dispatch(setError(error));
    dispatch(setLoading(false));
  };
}

export function putAssigments(interval) {
  return async function (dispatch, getState) {
    dispatch(setLoading(true));
    const [json, error] = await customFetch(`${BASE_URL}/scheduling`, {
      method: "POST",
      body: JSON.stringify(interval),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    if (json) {
      dispatch(getItervals(getToken()));
      dispatch(setLoading(false));
      dispatch(setOk("Assignments successfully added"));
      dispatch(setError(""));
      return;
    }
    dispatch(setOk(""));
    dispatch(setError(error));
    dispatch(setLoading(false));
  };
}
